import C from 'utils/values/constant.util';

const QUICK_HAIR_AND_BEAUTY = C({
  name: 'Quick Start Salon',
  pricing_type: 'role',
  phone: '12414212',
  postcode: 'WESADAWDA',
  roles: ['Stylist'],

  categories: [
    { name: 'Colouring', color: '#c93b7e' },
    { name: 'Ladies Cutting', color: '#3da49d' },
    { name: 'Ladies Styling', color: '#7300af' },
    { name: 'Gents Cutting', color: '#5e72d1' },
    { name: 'Consultations', color: '#9b9b9b' },
    { name: 'Staff Training', color: '#3da49d' },
  ],

  services: [
    {
      category: 'Colouring',
      name: 'Full Head Highlights',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '01:15:00',
          price: 80,
          processing: '00:45:00',
        },
      ],
    },
    {
      category: 'Colouring',
      name: 'Half Head Highlights',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '01:00:00',
          price: 65,
          processing: '00:45:00',
        },
      ],
    },
    {
      category: 'Colouring',
      name: 'Toner',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:15:00',
          price: 10,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Colouring',
      name: 'Long Hair Charge',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:15:00',
          price: 10,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Ladies Cutting',
      name: 'Ladies Cut & Blow Dry',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '01:00:00',
          price: 55,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Ladies Cutting',
      name: 'Ladies Cut & Blow Dry (Long Hair)',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '01:15:00',
          price: 65,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Ladies Styling',
      name: 'After Colour Blow Dry',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:45:00',
          price: 30,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Ladies Styling',
      name: 'Blow Dry',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:45:00',
          price: 40,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Gents Cutting',
      name: 'Gents Cut & Style',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:45:00',
          price: 35,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Consultations',
      name: 'Patch Test / Consultation',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '00:15:00',
          price: 0,
          processing: '00:00:00',
        },
      ],
    },
    {
      category: 'Staff Training',
      name: 'Colour Training Course',

      duration: '00:45:00',
      price: 40,
      processing: '00:00:00',
      variable_pricing: false,

      by_role: [
        {
          role: 'Stylist',
          duration: '01:30:00',
          price: 0,
          processing: '00:00:00',
        },
      ],
    },
  ],
  stylists: [
    {
      user_name: 'Example Stylist',
      gender: 'male',
      status: 'active',
      role: 'Stylist',
      categories: ['Colouring', 'Ladies Cutting', 'Ladies Styling', 'Gents Cutting', 'Consultations', 'Staff Training'],
      services: [
        {
          category: 'Colouring',
          name: 'Full Head Highlights',
        },
        {
          category: 'Colouring',
          name: 'Half Head Highlights',
        },
        {
          category: 'Colouring',
          name: 'Toner',
        },
        {
          category: 'Colouring',
          name: 'Long Hair Charge',
        },
        {
          category: 'Ladies Cutting',
          name: 'Ladies Cut & Blow Dry',
        },
        {
          category: 'Ladies Cutting',
          name: 'Ladies Cut & Blow Dry (Long Hair)',
        },
        {
          category: 'Ladies Styling',
          name: 'After Colour Blow Dry',
        },
        {
          category: 'Ladies Styling',
          name: 'Blow Dry',
        },
        {
          category: 'Gents Cutting',
          name: 'Gents Cut & Style',
        },
        {
          category: 'Consultations',
          name: 'Patch Test / Consultation',
        },
        {
          category: 'Staff Training',
          name: 'Colour Training Course',
        },
      ],
    },
  ],
  clients: [
    { user_name: 'Joey West', email: 'info@getslick.com', notes: '' },
    {
      user_name: 'James Heard',
      email: 'info@getslick.com',
      notes: 'Often late but rarely cancels',
    },
    {
      user_name: 'Jess Smith',
      email: 'info@getslick.com',
      notes: 'Had Majirel High Lift Ash+ last time and loved it',
    },
    { user_name: 'Rosie Smith', email: 'info@getslick.com', notes: '' },
    { user_name: 'Bee Ford', email: 'info@getslick.com', notes: '' },
    { user_name: 'Pia Jackson', email: 'info@getslick.com', notes: '' },
    {
      user_name: 'Steph Jones',
      email: 'info@getslick.com',
      notes: 'Sometimes cancels via text message but will rebook online',
    },
    { user_name: 'Lucy', email: 'info@getslick.com', notes: '' },
    {
      user_name: 'Mrs Williams',
      email: 'info@getslick.com',
      notes: 'Long thick hair that requires extra 15 for Blow Dry',
    },
  ],
  appointments: [
    {
      start_hour: '11:00',

      client_name: 'Joey West',
      status: 'paid',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Gents Cutting',
            name: 'Gents Cut & Style',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '13:00',

      client_name: 'James Heard',
      status: 'paid',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Gents Cutting',
            name: 'Gents Cut & Style',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '15:00',

      client_name: 'Jess Smith',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '90',

          service: {
            category: 'Colouring',
            name: 'Half Head Highlights',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
        {
          duration_minutes: '60',

          service: {
            category: 'Ladies Cutting',
            name: 'Ladies Cut & Blow Dry',
          },
          stylist_name: 'Example Stylist',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '16:45',

      client_name: '',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Ladies Styling',
            name: 'Blow Dry',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '18:15',

      client_name: 'Rosie Smith',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '15',

          service: {
            category: 'Consultations',
            name: 'Patch Test / Consultation',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '12:00',

      client_name: 'Bee Ford',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '75',

          service: {
            category: 'Ladies Cutting',
            name: 'Ladies Cut & Blow Dry (Long Hair)',
          },
          stylist_name: 'Example Stylist',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '14:15',

      client_name: 'Pia Jackson',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '75',

          service: {
            category: 'Ladies Cutting',
            name: 'Ladies Cut & Blow Dry (Long Hair)',
          },
          stylist_name: 'Example Stylist',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '19:00',

      client_name: 'Steph Jones',
      status: 'canceled',
      procedures: [
        {
          duration_minutes: '60',

          service: {
            category: 'Ladies Cutting',
            name: 'Ladies Cut & Blow Dry',
          },
          stylist_name: 'Example Stylist',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '21:00',

      client_name: 'Lucy',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '120',

          service: {
            category: 'Staff Training',
            name: 'Colour Training Course',
          },
          stylist_name: 'Example Stylist',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '16:45',

      client_name: 'Mrs Williams',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '90',

          service: {
            category: 'Colouring',
            name: 'Full Head Highlights',
          },
          stylist_name: 'Sophia',
          start_time: '1528124124241',
        },
        {
          duration_minutes: '75',

          service: {
            category: 'Colouring',
            name: 'Toner',
          },
          stylist_name: 'Sophia',
          start_time: '1528124124241',
        },
        {
          duration_minutes: '60',

          service: {
            category: 'Ladies Styling',
            name: 'After Colour Blow Dry',
          },
          stylist_name: 'Sophia',
          start_time: '1528124124241',
        },
      ],
    },
    {
      start_hour: '21:00',

      client_name: 'Lucy',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '120',

          service: {
            category: 'Staff Training',
            name: 'Colour Training Course',
          },
          stylist_name: 'Sophia',
          start_time: '1528124124241',
        },
      ],
    },
    {
      special: '2 days',

      client_name: '',
      status: 'confirmed',
      procedures: [
        {
          duration_minutes: '45',

          service: {
            category: 'Ladies Styling',
            name: 'Blow Dry',
          },
          stylist_name: 'Lucy',
          start_time: '1528124124241',
        },
      ],
    },
  ],
  times_off: [
    {
      start_hour: '21:00',
      duration_minutes: '180',

      stylist_name: 'Lucy',
      start_time: '142121212441',
      end_time: '151124121412',
    },
    {
      start_hour: '11:00',
      duration_minutes: '300',

      stylist_name: 'Sophia',
      start_time: '142121212441',
      end_time: '151124121412',
    },
  ],
});

// noinspection JSUnusedGlobalSymbols
export default QUICK_HAIR_AND_BEAUTY;
